import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserAuthorizationRoleReq } from 'app/models/use-auth-role-req';
import { ReportsService } from 'app/services';
import { EnvironmentsService } from 'app/services/enviornment.service';
import { AdminService } from './admin.service';

@Component({
    styleUrls: ['./admin.component.scss'],
    templateUrl: './admin.component.html'
})
export class AdminComponent implements OnInit,OnDestroy {
    collapsed: boolean = false;
    collapsible: boolean = true;
    langSub: any;
    constructor(private translateService: TranslateService, private envService: EnvironmentsService,private reportService: ReportsService){}
    menuItems: any = [];
    private readonly SUPER_ADMIN_AUTH_ROLE_ID: string = "1";

    ngOnInit(){
        this.langSub = this.envService.selectedLanguage$.subscribe((lang)=>{
            this.menuItems = [];
            this.menuItems.push({ name: this.translateService.instant('admin.leftNav'), link: ['managereleases'], hidden: false });

            // show Add Product option only to super Admins (1- Auth Role id of super admin)
            if(this.reportService.authRoleIds && Array.isArray(this.reportService.authRoleIds) && this.reportService.authRoleIds.includes(this.SUPER_ADMIN_AUTH_ROLE_ID)){
                this.menuItems.push({ name: this.translateService.instant('admin.addProdAdmin'), link: ['authorization'], hidden: false });
                this.menuItems.push({ name: this.translateService.instant('admin.addProduct'), link: ['addproduct'], hidden: false });
            }
        });
    }

    ngOnDestroy(){
        this.langSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts